import { memo } from "react";
import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { DesignMagazineAboutHotelListPresenter } from "./presenter";
import { useInitialized } from "../../model/use-case";

type Props = {
	hotelID: string;
};

export const DesignMagazineAboutHotelListContainer = memo(({ hotelID }: Props) => {
	const { data } = useInitialized({ hotelID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <DesignMagazineAboutHotelListPresenter hotelID={hotelID} data={data} />;
});

DesignMagazineAboutHotelListContainer.displayName = "DesignMagazineAboutHotelList";
